import React from 'react'
import {
  PointerLabel,
  ExpireLabel,
  FreePointLabel,
  PointIcon,
  AddSpan,
} from './CardStyled'
import styled from 'styled-components'
import * as skuHelper from 'helpers/skuHelper'
import { formatNumerics } from 'utils/formatUtil'
import { cent2dollar } from '@hk01-digital/wallet-internal-sdk'

const UnitLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #03070f;
  padding-left: 4px;
`
const SkuCardBottomV1 = (props) => {
  // amount is the value for buy coupon, and now BE is not implement
  const { pointsValue, publishEndAt } = props
  return (
    <>
      <PointerLabel>
        {pointsValue ? (
          <>
            {formatNumerics(pointsValue)}
            <UnitLabel>積分</UnitLabel>
          </>
        ) : (
          <FreePointLabel>免積分</FreePointLabel>
        )}
      </PointerLabel>
      {skuHelper.shouldShowExpiryCountdown({ publishEndAt }) && (
        <ExpireLabel>將到期</ExpireLabel>
      )}
    </>
  )
}

const SkuCardBottomV2 = (props) => {
  // amount is the value for buy coupon, and now BE is not implement
  const { pointsValue, publishEndAt, amount: exchangePrice } = props
  const formatAmount = exchangePrice
    ? formatNumerics(cent2dollar(exchangePrice))
    : 0
  return (
    <>
      <PointerLabel>
        {!!exchangePrice && <span>${formatAmount}</span>}
        {!!pointsValue && (
          <>
            {!!exchangePrice && <AddSpan>+</AddSpan>}
            <PointIcon />
            {formatNumerics(pointsValue)}
          </>
        )}
        {!(exchangePrice || pointsValue) && (
          <FreePointLabel>免费</FreePointLabel>
        )}
      </PointerLabel>
      {skuHelper.shouldShowExpiryCountdown({ publishEndAt }) && (
        <ExpireLabel>將到期</ExpireLabel>
      )}
    </>
  )
}

const SkuCardBottom = (props) => {
  const { paymentIntegration } = props
  return !paymentIntegration ? (
    <SkuCardBottomV1 {...props} />
  ) : (
    <SkuCardBottomV2 {...props} />
  )
}
export default SkuCardBottom
